import { TVariable } from 'src/types/variable'
import { TNavigationLocales } from 'src/types/locales'

const MIN_CHARACTERS = 3
const MAX_SUGGESTIONS = 5

export function getSuggestionsForLanguage(
  variables: TVariable[],
  language: TNavigationLocales,
  inputValue: string,
): TVariable[] {
  // Return empty if input is too short
  if (!inputValue || inputValue.length < MIN_CHARACTERS) {
    return []
  }

  const lowerCaseInput = inputValue.toLowerCase()

  // Filter variables that have a label for this language and match the input
  const filtered = variables.filter((variable) => {
    const labelForLanguage = variable.intlLabel?.[language]
    if (!labelForLanguage) return false

    return labelForLanguage.toLowerCase().includes(lowerCaseInput)
  })

  // Sort alphabetically by the language-specific label
  const sorted = filtered.slice().sort((a: TVariable, b: TVariable) => {
    const labelA = a.intlLabel?.[language] || ''
    const labelB = b.intlLabel?.[language] || ''
    return labelA.localeCompare(labelB)
  })

  // Return max 5 suggestions
  return sorted.slice(0, MAX_SUGGESTIONS)
}
